import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Modal, Select, TextField, Typography } from '@mui/material';import React, { useContext, useEffect, useRef, useState } from 'react'
import { ObtenerDepartamentos, ObtenerTiposUsuario } from '../../helpers/DepartamentosHelper';
import { ObtenerDirecciones } from '../../helpers/DireccionesHelper';
import { GuardarUsuario } from '../../helpers/UsuariosHelper';
import { UsuariosContext } from '../../pages/catalogos/UsuariosPage';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalAgregarUsuarioComponent = () => {
    const {modalAgregaUsuario, setModalAgregaUsuario, obtenerUsuarios, usuarioSeleccionado} = useContext(UsuariosContext);
    const [formUsuario, setFormUsuario] = useState({});
    const [tipoActivo, setTipoActivo] = useState();
    const [errorGuardado, setErrorGuardado] = useState(false);
    const refForm = useRef();
    const [direcciones, setDirecciones] = useState([]);
    const [opcionesDireccion, setOpcionesDireccion] = useState([])
    const [departamentos, setDepartamentos] = useState();
    const [tiposUsuario, setTiposUsuario] = useState();
    const handleClose = () => {
        setModalAgregaUsuario(false);
    }

    const handleSubmit =  (event) => {
        event.preventDefault();
        //refForm.current.isValidate();
        GuardarUsuario(formUsuario).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerUsuarios();
                handleClose();

            }
        })
    }

    const verificaAccion = () => {
      if(usuarioSeleccionado?.IdUsuario) {
        console.log('editando usuario', usuarioSeleccionado);
        setFormUsuario({
          ...formUsuario,
          idUsuario:usuarioSeleccionado.IdUsuario,
          usuario:usuarioSeleccionado.Usuario,
          password:usuarioSeleccionado.Password,
          nombre:usuarioSeleccionado.Nombre,
          aPaterno:usuarioSeleccionado.ApellidoPaterno,
          aMaterno:usuarioSeleccionado.ApellidoMaterno,
          correo:usuarioSeleccionado.Correo,
          telefonoOficina:usuarioSeleccionado?.TelefonoOficina,
          telefonoCelular:usuarioSeleccionado?.TelefonoCelular,
          idDepartamento:usuarioSeleccionado?.IdDepartamento,
          idDireccion:usuarioSeleccionado?.IdDireccion,
        })
      } else {
        console.log('agregando usuario');
      }
    }

    let obtenerDirecciones = async() => {
      const respuesta = await ObtenerDirecciones().then(datos=>{console.log('direcciones obtenidas para modal agregar usuario',datos);setDirecciones(datos)});
      console.log('datos obtenidos',respuesta);
  }

    let obtenerDepartamentos = async() => {
      const respuesta = await ObtenerDepartamentos().then(response => {
        console.log('Departamentos obtenidos',response);
        setDepartamentos(response)
      })
      console.log('respuesta con el async', respuesta);
    }

    const obtenerTiposUsuario= async() => {
      ObtenerTiposUsuario().then(response => {
        setTiposUsuario(response);
      })
    }



    useEffect(() => {
      verificaAccion();
      obtenerDirecciones();
      obtenerDepartamentos();
      obtenerTiposUsuario();
    }, [modalAgregaUsuario])
    
    useEffect(() => {
     // setDirecciones([]);
        direcciones.map(function(opcion) {
          setOpcionesDireccion([
            opcionesDireccion,
            {value:opcion.IdDireccion, label:opcion.Direccion}
          ])
      })    
//      setOpcionesDireccion(opciones);
  

    }, [direcciones])
    

    const actualizaUsuario = (dato, valor) => {
      setFormUsuario({
        ...formUsuario,
        [dato]:valor
      })
    }

    useEffect(() => {
      console.log('datos de usuario', formUsuario);
    }, [formUsuario])
    

  return (
      <div
        style={{
            minWidth:600
        }}
    >
     <Dialog open={modalAgregaUsuario} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>Usuario</DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          <TextField
            InputLabelProps={{shrink:true}}
            autoFocus
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="Usuario"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaUsuario('usuario',e.target.value)}
            value={formUsuario?.usuario}
          />
          <TextField
            InputLabelProps={{shrink:true}}
            margin="dense"
            label="Contraseña"
            type="password"
            fullWidth
            variant="standard"
            
            required={true}
            onChange={(e) => actualizaUsuario('password',e.target.value)}
            value={formUsuario?.password}
          />
          <TextField
            InputLabelProps={{shrink:true}}
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="Nombre"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaUsuario('nombre',e.target.value)}
            value={formUsuario?.nombre}
          />
          <TextField
            InputLabelProps={{shrink:true}}
            margin="dense"
            label="Apellido Paterno"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaUsuario('aPaterno',e.target.value)}
            value={formUsuario?.aPaterno}
          />
          <TextField
            InputLabelProps={{shrink:true}}
            margin="dense"
            label="Apellido Materno"
            type="text"
            fullWidth
            variant="standard"
            required={false}
            onChange={(e) => actualizaUsuario('aMaterno',e.target.value)}
            value={formUsuario?.aMaterno}
          />
          <TextField
            InputLabelProps={{shrink:true}}
            margin="dense"
            label="Correo"
            type="email"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaUsuario('correo',e.target.value)}
            value={formUsuario?.correo}
          />
          <TextField
            InputLabelProps={{shrink:true}}
            margin="dense"
            label="Teléfono oficina"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaUsuario('telefonoOficina',e.target.value)}
            value={formUsuario?.telefonoOficina}
          />
          <TextField
            InputLabelProps={{shrink:true}}
            margin="dense"
            label="Teléfono celular"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => actualizaUsuario('telefonoCelular',e.target.value)}
            value={formUsuario.telefonoCelular}
          />
       {/* <FormControl variant='standard' fullWidth>
        <InputLabel id="demo-simple-select-label">Dirección</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={formUsuario?.idDireccion || -1}
          label="Dirección"
          onChange={(event) => {console.log(event);actualizaUsuario('idDireccion', event.target.value)}}
          //onSelect={(event => handleChange(event))}
        >
          {
            direcciones?.map(direccion1 => (
              <MenuItem key={direccion1.idDireccion} value={direccion1.idDireccion}>{direccion1.direccion}</MenuItem>
            ))
          }
        </Select>
      </FormControl> */}
       <FormControl variant='standard' fullWidth>
        <InputLabel id="cboDepartamento-label">Departamento</InputLabel>
        <Select
          labelId="cboDepartamento"
          id="cboDepartamento"
          value={formUsuario?.idDepartamento || -1}
          label="Departamento"
          onChange={(event) => {console.log(event);actualizaUsuario('idDepartamento', event.target.value)}}
          //onSelect={(event => handleChange(event))}
        >
          {
            departamentos?.map(departamento => (
              <MenuItem key={departamento.idDepartamento} value={departamento.idDepartamento}>{departamento.descripcion}</MenuItem>
            ))
          }
        </Select>
      </FormControl>
       <FormControl variant='standard' fullWidth>
        <InputLabel id="cboTipoUsuario-label">Tipo de Usuario</InputLabel>
        <Select
          labelId="cboTipoUsuario"
          id="cboTipoUsuario"
          value={formUsuario?.idTipoUsuario || -1}
          label="Tipo de Usuario"
          onChange={(event) => {console.log(event);actualizaUsuario('idTipoUsuario', event.target.value)}}
          //onSelect={(event => handleChange(event))}
        >
          {
            tiposUsuario?.map(tipo => (
              <MenuItem key={tipo.idTipoUsuario} value={tipo.idTipoUsuario}>{tipo.descripcion}</MenuItem>
            ))
          }
        </Select>
      </FormControl>
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Guardar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
